import { useState, useCallback } from 'react';
import qs from 'query-string';

const setQueryStringWithoutPageReload = qsValue => {
  if (typeof window !== 'undefined') {
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${qsValue}`;

    window.history.pushState({ path: newurl }, '', newurl);
  }
};

const setQueryStringValue = (key, value, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({ ...values, [key]: value });
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

export const getQueryStringValue = (key, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  return values[key];
};

const useQueryString = (key, initialValue, isInt) => {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(
    newValue => {
      setValue(isInt ? parseFloat(newValue) : newValue);
      setQueryStringValue(key, newValue);
    },
    [key, isInt]
  );

  return [value, onSetValue];
};

export default useQueryString;
